import { useEffect } from 'react';
import warning from 'tiny-warning';

export function useShorthandAndFullPropConflictWarning(
  condition: boolean,
  componentName: string,
  [shorthandPropName, fullPropName]: [string, string]
) {
  useEffect(() => {
    warning(
      condition,
      `Свойство ${shorthandPropName} является сокращением свойства ${fullPropName} для компонента ${componentName}. Не следует использовать эти свойства одновременно.`
    );
  }, [condition]);
}
